module.exports = __webpack_public_path__ + "static/media/9.fbfb93e7.png";